
export const pieChart =
{
  type: 'doughnut',
  data: {
    labels: [],
    datasets: [{
      data: [],
      hoverBorderColor: "#99ff99",
    }],
  },
  options: {
    animation: false,
    maintainAspectRatio: false,
    tooltips: {
      backgroundColor: "rgb(255,255,255)",
      bodyFontColor: "#858796",
      borderColor: '#dddfeb',
      borderWidth: 1,
      xPadding: 15,
      yPadding: 15,
      displayColors: false,
      caretPadding: 10,
    },
    legend: {
      display: true
    },
    cutoutPercentage: 0
  },
}